export default "__VITE_ASSET__DUcp9F4F__"